import { Link } from "react-router-dom";
import { ArrowRight, Languages, BadgeCheck } from "lucide-react";
import { LANGUAGECERT } from "@/lib/content";

/**
 * Compact cross-sell strip surfacing English-exam requirements + the
 * LanguageCert discount code. Drop into program pages (Bachelor, Master,
 * Medicine & Dentistry, PhD) to nudge applicants toward the right test.
 *
 * Props:
 *   - level: short text like "B2" or "C1" shown in the chip
 *   - context: optional copy override
 */
export default function EnglishExamCrossSell({
  level = "B2",
  context = "Most English-taught programs require",
  testId = "english-cross-sell",
}) {
  return (
    <section className="py-16" data-testid={testId}>
      <div className="container-sp">
        <div className="relative overflow-hidden rounded-2xl border border-[#EFEEE8] bg-white grid md:grid-cols-12 gap-6 items-center p-7 md:p-10">
          <div
            aria-hidden
            className="absolute -top-16 -right-16 w-72 h-72 rounded-full blur-3xl opacity-30"
            style={{ background: "radial-gradient(circle, #D7141A 0%, transparent 70%)" }}
          />

          <div className="md:col-span-7 relative">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#F5E8E9] text-[11px] font-semibold tracking-[0.18em] uppercase text-[#D7141A]">
              <Languages className="w-3.5 h-3.5" /> English at a glance · {level}
            </div>
            <h3 className="font-serif text-2xl md:text-3xl text-[#0D1B2A] mt-4 leading-tight">
              {context} CEFR <span className="text-[#D7141A]">{level}</span>.
            </h3>
            <p className="text-sm text-[#4A5568] mt-3 leading-relaxed max-w-lg">
              We help you pick the right accredited exam — including
              LanguageCert International ESOL, accepted across Polish
              universities. Get our official discount before you register.
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-[#0D1B2A]">
              <span className="inline-flex items-center gap-1.5">
                <BadgeCheck className="w-3.5 h-3.5 text-[#D7141A]" /> Accredited
              </span>
              <span className="inline-flex items-center gap-1.5">
                <BadgeCheck className="w-3.5 h-3.5 text-[#D7141A]" /> Online & test-centre
              </span>
              <span className="font-mono text-[11px] bg-[#0D1B2A] text-white px-2.5 py-1 rounded-md tracking-[0.2em]">
                Code · {LANGUAGECERT.discountCode}
              </span>
            </div>
          </div>

          <div className="md:col-span-5 relative flex md:justify-end">
            <Link
              to="/english-exam"
              className="btn-primary"
              data-testid={`${testId}-cta`}
            >
              See English Requirements <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
